import { render, staticRenderFns } from "./SalesOrderList.vue?vue&type=template&id=fecf652a&scoped=true"
import script from "./SalesOrderList.vue?vue&type=script&lang=js"
export * from "./SalesOrderList.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderList.vue?vue&type=style&index=0&id=fecf652a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecf652a",
  null
  
)

export default component.exports